module.exports = __webpack_public_path__ + "img/experiments_09_hr_u1_v1.8544d5a0.png";